import { createGlobalStyle } from 'styled-components';

import Colors from 'utils/Colors';
import Responsive from 'utils/ResponsiveValues';

/* eslint no-unused-expressions: 0 */
const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    color: ${Colors.white};
    background-color: ${Colors.sidebarBackground};
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  body {
    font-family: 'Raleway', sans-serif;
  }

  body.fontLoaded {
    font-family: 'Raleway', sans-serif;
  }

  #app {
    background-color: ${Colors.sidebarBackground};
    min-height: 100%;
    min-width: 100%;
  }

  button, textarea {
    font-family: 'Raleway', sans-serif !important;
  }

  button:focus, input:focus {
    outline: 0;
  }

  h1 {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    word-spacing: normal;
  }

  h2, h3, h4, h5, h6 {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    word-spacing: normal;
  }

  .react-datepicker {
    font-family: 'Raleway', sans-serif !important;
  }

  .StripeElement {
    width: 80%;
    background: white;
    border-radius: 20px;
    padding: 7px 10px;
    border: 1px solid #ccc;
    box-shadow: 1px 1px 1px 0 #ccc;
    font-family: 'Raleway', sans-serif !important;

    @media(max-width: ${Responsive.sidebarMedium}px) {
      width: 100%;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes grow {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(2);
    }

    100% {
      transform: scale(1);
    }
  }
`;

export default GlobalStyle;
